$(".sizeguide-modal-toggle").on("click", function (t) {
    t.preventDefault(), $(".sizeguide-modal").toggleClass("is-visible");
    var e = document.getElementById("shopify-section-header");
    console.log(e), e.classList.toggle("header-order");
}),

    $(document).on("click", 'a[href^="#"]', function (t) {
        t.preventDefault(),
            console.log("si"),
            $("html, body").animate({ scrollTop: $($.attr(this, "href")).offset().top - 100 }, 500);
    });



function openAccordion(t) {
    var e = $(t).parent();
    e.toggleClass("open"), e.find(".acc-body").toggleSlide();
}
function productOpenDescription() {
    $(".product-wrapper .description-full").addClass("open");
}
function productCloseDescription() {
    $(".product-wrapper .description-full").removeClass("open");
}
function productOpenInstoreAvailability() {
    $(".product-wrapper .instore-availability").addClass("open");
}
function productCloseInstoreAvailability() {
    $(".product-wrapper .instore-availability").removeClass("open");
}
function addProductToCart(t) {
    var e = this,
        n = { form_type: "product", utf8: "\u2713", id: t, quantity: 1 };
    fetch("".concat(window.routes.cartAddUrl, ".js"), {
        body: JSON.stringify(n),
        credentials: "same-origin",
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
    }).then(function (o) {
        document.dispatchEvent(new CustomEvent("theme:loading:end")),
            o.ok
                ? (e.element.dispatchEvent(
                      new CustomEvent("product:added", {
                          bubbles: !0,
                          detail: {
                              variant: e.currentVariant,
                              quantity: quantityElement ? parseInt(quantityElement.value) : 1,
                          },
                      })
                  ),
                  console.log("added"))
                : o.json().then(function (r) {
                      var i = document.createElement("span");
                      (i.className = "ProductForm__Error Alert Alert--error"),
                          (i.innerHTML = r.description),
                          setTimeout(function () {
                              i.remove();
                          }, 2500);
                  });
    }),
        event.preventDefault();
}
function renderCart() {
    fetch(
        ""
            .concat(window.routes.cartUrl, "?section_id=")
            .concat(this.options.drawer && window.theme.pageType !== "cart" ? "mini-cart" : "main-cart", "&timestamp=")
            .concat(Date.now()),
        { credentials: "same-origin", method: "GET" }
    ).then(function (t) {
        if (_this4.options.drawer && elementToAnimate) {
            var e = new TimelineLite({
                onComplete: function () {
                    t.text().then(function (o) {
                        _this4._replaceContent(o);
                    });
                },
            });
            e.to(elementToAnimate, 0.5, { height: 0, opacity: 0, ease: Cubic.easeOut }, 0),
                _this4.itemCount === 0 &&
                    e.to(
                        _this4.element.querySelector(".Drawer__Footer"),
                        0.5,
                        { y: "100%", transition: "none", ease: Cubic.easeInOut },
                        0
                    );
        } else
            t.text().then(function (n) {
                _this4._replaceContent(n);
            });
    });
}
//# sourceMappingURL=/s/files/1/0412/1080/6434/t/40/assets/graphic.js.map?v=1672938675
